/* eslint-disable no-use-before-define */
import React from 'react'
import { Summary } from './summary-table/summary'
import { Table } from './summary-table/table'
export const SummaryTable = ({context}) => {

    return <React.Fragment>
        <Summary context={context} />
        <Table context={context} />
    </React.Fragment>
}




// WEBPACK FOOTER //
// ./src/trade-history/summary-table.js